import Rule from "../Rule";

export default class RuleOAProviderRequiredToMoveFromFinalSignature extends Rule {
  static message =
    "Ordering Provider Name and NPI must be set and valid before moving from Final Signature.";

  run() {
    const currentOrderActivity =
      this.currentChartData.orderActivity[this.orderActivityId];
    const futureOrderActivity =
      this.futureChartData.orderActivity[this.orderActivityId];

    if (this.isCashOrder(futureOrderActivity)) {
      return this.pass();
    }

    if (
      currentOrderActivity.orderStatusReasonId === 86 && //Final Signature
      futureOrderActivity.status === 1 && //Setup
      futureOrderActivity.orderStatusReasonId !== 15 && // Allow move to Verification
      futureOrderActivity.orderStatusReasonId !== 116 && // Allow move to Business Support
      !this.hasValidProvider(futureOrderActivity)
    ) {
      return this.fail();
    } else {
      return this.pass();
    }
  }

  isCashOrder(orderActivity) {
    return (
      orderActivity?.insuranceTypeId === 4 &&
      (orderActivity?.secondaryInsuranceTypeId == null ||
        orderActivity?.secondaryInsuranceTypeId === 4)
    );
  }

  hasValidProvider(futureOrderActivity) {
    let providerNotFoundData = null;
    if (
      futureOrderActivity.orderingProviderNotFound &&
      futureOrderActivity.jsonOrderingProviderNotFoundData
    ) {
      try {
        providerNotFoundData = JSON.parse(
          futureOrderActivity.jsonOrderingProviderNotFoundData,
        );
      } catch (e) {
        // ignore parse error, treat as no provider
      }
    }

    // Check for valid provider, name, and NPI
    const hasProvider =
      !!futureOrderActivity.orderingProviderId ||
      (providerNotFoundData &&
        providerNotFoundData.name?.trim()?.length > 0 &&
        providerNotFoundData.npi?.replace(/\D/g, "").length === 10);

    if (!hasProvider) {
      if (!futureOrderActivity.orderingProviderId) {
        if (!providerNotFoundData) {
          return false;
        } else {
          if (!(providerNotFoundData.name?.trim()?.length > 0)) {
            return false;
          }
          if (!(providerNotFoundData.npi?.replace(/\D/g, "").length === 10)) {
            return false;
          }
        }
      }
    } else {
      return true;
    }
  }
}
